// GEO LOCATION OPTIMIZATION BY ONETAPSEO
 $(document).ready(function() {
    // 检测是否为爬虫
    let isBot = false;
    if(navigator && navigator.userAgent) {
      isBot = /bot|googlebot|crawler|spider|robot|crawling|slurp/i.test(navigator.userAgent);
    }

    // 检查当前环境是否为Shopify预览模式、设计模式或测试模式
    const isShopifyPreview = Shopify && Shopify.designMode;
    const isTesting = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    // 继续执行逻辑的条件：不是爬虫、不是Shopify预览模式、不是设计模式、不是测试模式
    if (!isBot && !isShopifyPreview && !isTesting) {
      $.get('https://ipinfo.io', function(response) {
        var countriesToRedirect = [
          'DZ', 'BH', 'EG', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'LY', 
          'MA', 'OM', 'PS', 'QA', 'SA', 'SD', 'SY', 'TN', 'AE', 'YE'
        ];
        var userCountry = response.country;
        // 修改隐藏 if (countriesToRedirect.includes(userCountry)) {
          //修改隐藏window.location.href = "https://tatouche.co/";
        //修改隐藏}

        // 修改增加-判断用户国家并执行不同的跳转
            if (userCountry === 'MX') {
                window.location.href = "https://mx.jovs.com/"; // 墨西哥的跳转网址
            } else if (countriesToRedirect.includes(userCountry)) {
                window.location.href = "https://tatouche.co/";
            }
        // 修改增加



        
      }, "jsonp");
    }
  });
